import { hotComics } from '@/mocks/home';

export default function HotComicsSection() {
  return (
    <section id="hot" className="relative py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-10">
        <div className="flex flex-col sm:flex-row sm:items-end justify-between mb-10 md:mb-12 max-w-6xl mx-auto">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-black text-foreground-950">
              热门漫画
            </h2>
            <p className="text-sm text-foreground-600 mt-2">
              每日更新 · 全网最速
            </p>
          </div>
          <a
            href="#"
            className="mt-3 sm:mt-0 inline-flex items-center gap-1 text-sm font-medium text-accent-500 hover:text-accent-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 max-w-6xl mx-auto" data-product-shop="">
          {hotComics.map((comic) => (
            <div
              key={comic.id}
              className="group cursor-pointer"
            >
              <div className="relative rounded-xl overflow-hidden aspect-[3/4] bg-background-100">
                <img
                  src={comic.coverImage}
                  alt={comic.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                  title={`歪歪漫画 - ${comic.title}`}
                />
                <div className="absolute top-3 right-3">
                  <span className="px-2.5 py-1 rounded-full text-xs font-medium bg-accent-500 text-background-50">
                    {comic.tag}
                  </span>
                </div>
                <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-primary-950/80 via-primary-950/40 to-transparent p-4 pt-12">
                  <h3 className="font-heading text-sm md:text-base font-bold text-background-50">
                    {comic.title}
                  </h3>
                  <p className="text-xs text-background-50/60 mt-1 flex items-center gap-1">
                    <i className="ri-time-line text-xs"></i>
                    {comic.chapter}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="flex items-center justify-center gap-4 mt-10 md:mt-12">
          <a
            href="#"
            className="px-6 py-2.5 rounded-full bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
          >
            加载更多漫画
          </a>
          <a
            href="#"
            className="px-6 py-2.5 rounded-full text-sm font-medium text-foreground-700 hover:text-accent-500 border border-secondary-300 hover:border-accent-400 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            查看排行 <i className="ri-bar-chart-line ml-1"></i>
          </a>
        </div>
      </div>
    </section>
  );
}